module.exports = __webpack_public_path__ + "media/images/official/special_double_life_worry_area-f26a216692da8da5650acdff86dffd00.png";